module.exports = __webpack_public_path__ + "static/media/Tickets_Collected.a3e3871e.png";